import {toRaw} from 'vue'

export function deepToRaw(value) {
  const raw = toRaw(value)

  if (Array.isArray(raw)) {
    return raw.map(item => deepToRaw(item))
  }

  if (raw !== null && typeof raw === 'object') {
    const result = {}
    for (const key in raw) {
      result[key] = deepToRaw(raw[key])
    }
    return result
  }

  return raw
}

export function isObject(obj) {
  return typeof obj === 'object' && obj !== null
}

export function same(a, b) {
  if (!isObject(a) || !isObject(b)) throw new Error(`Objects expected, got ${typeof a} and ${typeof b}`)
  return JSON.stringify(a) === JSON.stringify(b)
}

export function proxy_assign(to, from) {
  // TODO: check if we really need this
  //       may be Object.assign would go through proxy as well
  for (const key in from) {
    to[key] = from[key]
  }
}

export function ensure_keys(object, keys) {
  for (const key of keys) {
    if (key in object) continue
    throw new Error(`Missing key ${key} in object ${JSON.stringify(object)}`)
  }
}

export function deepCopy(obj, weakMap = new WeakMap()){
  if (typeof structuredClone === 'function') {
    return structuredClone(deepToRaw(obj))
  }

  if (obj === null || typeof obj !== 'object') return obj

  if (weakMap.has(obj)) return weakMap.get(obj)

  let copy

  if (obj instanceof Date) {
    copy = new Date(obj)
  } else if (obj instanceof Map) {
    copy = new Map()
    weakMap.set(obj, copy)
    obj.forEach((v, k) => {
      copy.set(deepCopy(k, weakMap), deepCopy(v, weakMap))
    })
  } else if (obj instanceof Set) {
    copy = new Set()
    weakMap.set(obj, copy)
    obj.forEach(v => {
      copy.add(deepCopy(v, weakMap))
    })
  } else if (Array.isArray(obj)) {
    copy = []
    weakMap.set(obj, copy)
    obj.forEach((v, i) => {
      copy[i] = deepCopy(v, weakMap)
    })
  } else {
    copy = {}
    weakMap.set(obj, copy)
    Object.keys(obj).forEach(k => {
      copy[k] = deepCopy(obj[k], weakMap)
    })
  }
  return copy
}

export function removeKey(obj, keyToRemove) {
  if (Array.isArray(obj)) {
    return obj.map(item => removeKey(item, keyToRemove))
  }

  if (obj !== null && typeof obj === 'object') {
    const result = {}
    for (const [key, value] of Object.entries(obj)) {
      if (key === keyToRemove) continue
      result[key] = removeKey(value, keyToRemove)
    }
    return result
  }

  return obj
}

export function getChangedFields(oldObj, newObj) {
  return Object.fromEntries(
    Object.entries(newObj).filter(
      ([key, value]) => oldObj[key] !== value
    )
  )
}

